import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Head from "../components/Head";
import Layout from "../components/layout1";
import LegalAndPrivacyPage from "../components/legalAndPrivacy/LegalAndPrivacyPage";
import LegalPrivacyLeft from "../components/legalAndPrivacyLeft/legalPrivacyLeft";
import { LegalAndPrivacyContext } from "../context/LegalAndPrivacyContext";
import { useQuery } from "../utils/useQuery";

const LegalPrivacySummary = () => {
  const { setCurrentPage } = useContext(LegalAndPrivacyContext);
  const query = useQuery();
  const navigate = useNavigate();
  useEffect(() => {
    const querName = query.get("name");
    if (querName) setCurrentPage(querName);
  }, [query, setCurrentPage]);

  const onBackButtonClick = () => {
    navigate(-1);
    const queryName = query?.get("name");
    if (queryName) {
      setCurrentPage(queryName);
    }
  };
  return (
    <div>
      <Head>
        <title>Legal & Privacy</title>
      </Head>
      <Layout
        backButton={true}
        onBackBtnClick={onBackButtonClick}
        desktopLeftMain={<LegalPrivacyLeft />}
        desktopRightMain={<LegalAndPrivacyPage />}
      />
    </div>
  );
};
export default LegalPrivacySummary;
